module.exports = __webpack_public_path__ + "static/media/background.77f7e55e.png";